import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { captureOrgId, captureTxnId } from "../common";

// Salesforce passes org_id and txn_id on the initial redirect. React Router drops the
// query string on navigation, so re-attach the persisted values to the URL on every
// location change — they must survive login -> change password -> face -> checkin.
export function SalesforceParamsKeeper() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const persisted: Record<string, string> = {
      org_id: captureOrgId(),
      txn_id: captureTxnId(),
    };
    const params = new URLSearchParams(location.search);
    let changed = false;
    for (const [key, value] of Object.entries(persisted)) {
      if (value && params.get(key) !== value) {
        params.set(key, value);
        changed = true;
      }
    }
    if (changed) {
      navigate({ pathname: location.pathname, search: `?${params.toString()}` }, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return null;
}
